module.exports = __webpack_public_path__ + "img/default_shop.1fa645e5.png";